import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { map } from 'rxjs/operators';
import { Observable } from "rxjs/Observable";
import { interval } from "rxjs/observable/interval";
import Cookies from 'js-cookie';

@Injectable()
export class SessionService {

    constructor() {}

    isUserSessionExpired(): Observable<boolean> {
        return interval(1000)
            .pipe(
                    map((val) => {
                        if (Cookies.get('csrftoken') == null || Cookies.get('sessionid') == null) {
                            document.cookie = "isStaff=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
                            document.cookie = "OLAP_UserGroup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
                            document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
                            document.cookie = "sessionid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
                            return true;
                        }
                        return false;
                    }
                )
            );
    }
}



// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/service/session.service.ts